import * as React from 'react'
import styled from 'styled-components'

import { mq } from '@styles/responsive'

const Wrapper = styled.div`
  overflow-x: auto;
  margin-bottom: 30px;
  ${mq({
    marginBottom: [10, 10],
    maxWidth: ['calc(100vw - 40px)', 'calc(100vw - 80px)', '100%'],
  })};
`

const TableStyled = styled.table`
  width: 100%;
  margin-top: 10px;
  table-layout: auto;
  background-color: transparent;
  border-spacing: 0;
  border-collapse: collapse;
  border-style: hidden;
  font-size: 14px;
  color: ${p => p.theme.colors.tableColor};
  ${mq({
    overflowX: ['initial', 'initial', 'initial', 'hidden'],
    display: ['table', 'table', 'table', 'table'],
  })}
  & thead {
    color: ${p => p.theme.colors.theadColor};

    tr {
      border-bottom: 1px solid ${p => p.theme.colors.border};
    }
  }
  & thead th {
    font-weight: 00;
    padding: 7px 0;
    color: gray;
    text-align: left;
    min-width: 80px;
    &:nth-of-type(1) {
      ${mq({
        width: ['20%', '20%', '20%', 'auto'],
      })};
    }
    &:nth-of-type(2) {
      ${mq({
        width: ['10%', '10%', '10%', 'auto'],
      })};
    }
    &:nth-of-type(3) {
      ${mq({
        width: ['10%', '10%', '10%', 'auto'],
      })};
    }
    &:nth-of-type(4) {
      ${mq({
        width: ['10%', '10%', '10%', 'auto'],
      })};
    }
    &:nth-of-type(5) {
      ${mq({
        width: ['20%', '20%', '20%', 'auto'],
      })};
    }
  }
  & tbody td {
    padding: 5px 0;
    line-height: 1.6;
    font-weight: 13px;
    font-weight: 400;
    max-width: 360px;
    vertical-align: top;
    color: #616161;

    strong {
      font-size: 13px;
      font-weight: 600;
      color: #616161;
    }

    code {
      word-break: break-all;
      white-space: pre-wrap;
      background-color: transparent;
      padding: 0;
    }

    br + code {
      margin: -5px 0 0;
      padding: 0;
      font-size: 12px;
      font-weight: 600;
      font-family: pingfontweb, -apple-system, BlinkMacSystemFont,
        Helvetica Neue, Helvetica, Roboto, Arial, PingFang SC, Hiragino Sans GB,
        Microsoft Yahei, Microsoft Jhenghei, sans-serif;
      line-height: 10px;
      background-color: transparent;
    }

    br + em {
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      color: #bbb;
    }

    li {
      margin: 4px;
      font-size: 13px;
      line-height: 1.7;
    }
  }
  & tbody > tr {
    display: table-row;
    border-bottom: 1px solid ${p => p.theme.colors.border};

    &:nth-of-type(1) {
      border-color: rgb(240, 244, 247);
    }
  }
`

export const Table = (props: React.TableHTMLAttributes<any>) => (
  <Wrapper>
    <TableStyled {...props} />
  </Wrapper>
)
